import { render, staticRenderFns } from "./DReactBtn.vue?vue&type=template&id=a141bc60&scoped=true&"
import script from "./DReactBtn.vue?vue&type=script&lang=js&"
export * from "./DReactBtn.vue?vue&type=script&lang=js&"
import style0 from "./DReactBtn.vue?vue&type=style&index=0&id=a141bc60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a141bc60",
  null
  
)

export default component.exports